import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { config } from "./config";
import "./styles/App.scss";

function Header() {
  const navigate = useNavigate();
  const location = useLocation();
  const selectRef = useRef<HTMLSelectElement>(null);

  useEffect(() => {
    resizeSelect();
  }, []);

  function resizeSelect() {
    const select = selectRef.current;
    if (!select) {
      return;
    }
    const sizer = document.createElement("span");
    sizer.style.visibility = "hidden";
    sizer.style.position = "absolute";
    sizer.style.whiteSpace = "nowrap";
    sizer.style.font = getComputedStyle(select).font;
    sizer.textContent = select.options[select.selectedIndex].text;
    document.body.appendChild(sizer);
    select.style.width = `${sizer.offsetWidth + 20}px`;
    document.body.removeChild(sizer);
  }

  return (
    <div className="header">
      <button onClick={() => navigate("/")} className="logo">
        <div className="headerContainer">
          <div className="name">
            <mark>RATE</mark>
            <mark>YOUR</mark>
            <mark>LANDLORD</mark>{" "}
            {location.pathname === "/" ? (
              <select
                ref={selectRef}
                className="reversed city-selector"
                name="selectedCity"
                value={config.CITY}
                onChange={(e) => {
                  window.location.href = `https://rateyourlandlord${e.target.value.toLowerCase()}.com`;
                }}
              >
                {config.CITIES.map((city) => (
                  <option value={city}>{city}</option>
                ))}
              </select>
            ) : (
              <span className="reversed">{config.CITY}</span>
            )}
            <mark>.COM</mark>
          </div>
        </div>
      </button>
    </div>
  );
}

export default Header;
